(function (root, factory) {
  'use strict';
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.PesadoCartFitEngine = factory();
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';
  function id(value) { return String(value || '').replace(/^gid:\/\/shopify\/ProductVariant\//, ''); }
  function evaluate(cart, rules) {
    var profiles = new Map(rules.profiles.filter(function (profile) { return profile.verified; }).map(function (profile) { return [id(profile.variantId), profile]; }));
    var unknown = [], unknownTotals = new Map(), roots = [], atoms = [], connections = [];
    (cart.items || []).forEach(function (line) {
      var variantId = id(line.variant_id || line.id), quantity = Number(line.quantity);
      if (!Number.isInteger(quantity) || quantity < 1) return;
      var profile = profiles.get(variantId);
      if (!profile) { unknown.push(variantId); unknownTotals.set(variantId, (unknownTotals.get(variantId) || 0) + quantity); return; }
      if (profile.universal && !profile.connections?.length && !(profile.components || []).some(function (part) { return part.connections?.length || Object.keys(part.dimensions || {}).length || part.fitFamilies?.length; })) return;
      var entry = roots.find(function (item) { return item.variantId === variantId; });
      if (entry) { entry.quantity += quantity; return; }
      roots.push({ variantId: variantId, label: profile.label || line.product_title, productTitle: line.product_title || profile.label, variantTitle: line.variant_title || '', sku: line.sku || profile.sku, productType: profile.productType, quantity: quantity, size: profile.commercialSize, conditions: profile.conditions || [], components: profile.components || [], profile: profile });
    });
    roots.forEach(function (entry) {
      var parts = [Object.assign({ id: 'variant', quantity: 1 }, entry.profile)].concat(entry.components);
      parts.forEach(function (part) {
        if (!part.verified) { unknown.push(entry.variantId); return; }
        var dimensions = part.dimensions || { basket: part.fitFamilies || [] };
        Object.keys(dimensions).forEach(function (dimension) { if (dimensions[dimension].length) atoms.push({ root: entry, component: part.id, dimension: dimension, families: dimensions[dimension] }); });
        (part.connections || []).forEach(function (connection) { connections.push({ root: entry, component: part.id, group: connection.group, role: connection.role, families: connection.fits }); });
      });
    });
    var conflicts = [], involved = new Set();
    function addConflict(rule, a, b) {
      involved.add(a.root.variantId); involved.add(b.root.variantId);
      if (!conflicts.some(function (existing) { return existing.id === rule.id; })) conflicts.push({ id: rule.id, dimension: rule.dimension || 'basket', message: rule.message });
    }
    function matches(rule, a, b) {
      if (a.families.some(function (family) { return b.families.indexOf(family) >= 0; })) return false;
      return (a.families.indexOf(rule.families[0]) >= 0 && b.families.indexOf(rule.families[1]) >= 0) || (a.families.indexOf(rule.families[1]) >= 0 && b.families.indexOf(rule.families[0]) >= 0);
    }
    (rules.conflicts || []).filter(function (rule) { return rule.verified; }).forEach(function (rule) {
      if (rule.dimension === 'connection') return;
      for (var left = 0; left < atoms.length; left++) {
        for (var right = left + 1; right < atoms.length; right++) {
          var a = atoms[left], b = atoms[right];
          if (a.root.variantId === b.root.variantId || a.dimension !== b.dimension || a.dimension !== (rule.dimension || 'basket')) continue;
          // Overlapping explicit fit alternatives are not a proven conflict.
          if (a.families.some(function (family) { return b.families.indexOf(family) >= 0; })) continue;
          if (matches(rule, a, b)) addConflict(rule, a, b);
        }
      }
    });
    var accessoryGroups = new Map();
    connections.filter(function (connection) { return connection.role === 'accessory'; }).forEach(function (connection) {
      var key = connection.root.variantId + ':' + connection.group;
      if (!accessoryGroups.has(key)) accessoryGroups.set(key, []);
      accessoryGroups.get(key).push(connection);
    });
    accessoryGroups.forEach(function (accessories) {
      var allTools = connections.filter(function (tool) { return tool.role === 'tool' && tool.group === accessories[0].group; });
      // Buying a set of spare handles does not require every handle to fit every tool.
      if (accessories.some(function (accessory) { return allTools.some(function (tool) { return accessory.families.some(function (value) { return tool.families.indexOf(value) >= 0; }); }); })) return;
      var tools = allTools.filter(function (tool) { return tool.root.variantId !== accessories[0].root.variantId; });
      accessories.forEach(function (accessory) { tools.forEach(function (tool) {
        (rules.conflicts || []).filter(function (rule) { return rule.verified && rule.dimension === 'connection'; }).forEach(function (rule) { if (matches(rule, accessory, tool)) addConflict(rule, accessory, tool); });
      }); });
    });
    var relevant = roots.map(function (item) { return { variantId: item.variantId, quantity: item.quantity }; });
    unknownTotals.forEach(function (quantity, variantId) { relevant.push({ variantId: variantId, quantity: quantity, unverified: true }); });
    relevant.sort(function (a, b) { return a.variantId.localeCompare(b.variantId); });
    return {
      status: conflicts.length ? 'conflict' : unknown.length ? 'insufficient_data' : 'compatible',
      scope: 'configured_verified_fit_rules_only',
      unknownVariantIds: Array.from(new Set(unknown)).sort(),
      conflicts: conflicts,
      items: roots.filter(function (item) { return involved.has(item.variantId); }).map(function (item) { var copy = Object.assign({}, item); delete copy.profile; return copy; }),
      composition: JSON.stringify(relevant)
    };
  }
  function fitSensitive(profile) {
    return !!profile && [profile].concat(profile.components || []).some(function (part) {
      return (part.fitFamilies || []).length || Object.values(part.dimensions || {}).some(function (values) { return values.length; }) || (part.connections || []).length;
    });
  }
  function canRecommend(cart, additions, rules) {
    var profiles = new Map(rules.profiles.filter(function (profile) { return profile.verified; }).map(function (profile) { return [id(profile.variantId), profile]; }));
    var proposed = additions.map(function (line) { return { variant_id: id(line.variant_id || line.id), quantity: Number(line.quantity || 1) }; });
    if (!proposed.length || proposed.some(function (line) { return !profiles.has(line.variant_id) || !Number.isInteger(line.quantity) || line.quantity < 1; })) return false;
    var result = evaluate({ items: (cart.items || []).concat(proposed) }, rules);
    if (result.unknownVariantIds.length && proposed.some(function (line) { return fitSensitive(profiles.get(line.variant_id)); })) return false;
    return !result.items.some(function (item) { return proposed.some(function (line) { return line.variant_id === item.variantId; }); });
  }
  return { evaluate: evaluate, variantId: id, fitSensitive: fitSensitive, canRecommend: canRecommend };
});
